export default $api => {
  $api.register('insurance-api', '/web/private/client', request => ({
    getInsuranceDebtItems({ withInsurance, amount } = { withInsurance: true }) {
      const params = {
        withFastFee: 0,
        withInsurance: Number(withInsurance),
      };

      if (amount) {
        params.amount = amount;
      }

      return request('GET', '/debt-items', { params });
    },
    acceptWithInsurance(payload) {
      return request('POST', '/active-application-insurance/accept', payload);
    },
    acceptWithoutInsurance(payload) {
      return request('POST', '/active-application-without-insurance/accept', payload);
    },
    acceptWithGuarantor(payload) {
      return request('POST', '/active-application-with-guarantor/accept', payload);
    },
  }));
};
